import { gql } from "@apollo/client";
import { lensSourceListItemFragment } from "../fragments";

export const getCachedLensSourceList = gql`
    query getCachedLensSourceList($lensSourceType: LenssourceModelLensSourceType) {
        selectedOrganization @client {
            id @export(as: "organizationId")
        }
        getLensSourceList(
            input: { limit: 0, query: null, organizationId: null, lensSourceType: $lensSourceType, cursor: null }
        ) {
            lensSourceList {
                ...LensSourceListItem
            }
            cursor
        }
    }
    ${lensSourceListItemFragment}
`;
